import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateCustomAuthenticationFactorRequirementsApi = createApi({
  reducerPath: 'policyTemplateCustomAuthenticationFactorRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getCustomAuthenticationFactorRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/custom-authentication-factor-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetCustomAuthenticationFactorRequirementsPreviewQuery } =
  policyTemplateCustomAuthenticationFactorRequirementsApi

export const useCustomAuthenticationFactorRequirementsPreview = (
  { templateId, customerId: customerIdOverride },
  options = {},
) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  // Deploy from a check can target a different tenant than the globally selected customer.
  const customerId = customerIdOverride ?? selectedCustomerId

  // Deploy resolves against the tenant's live policies, so every review must too — a cached result
  // could show "Will be adopted" after the template or the tenant's policies changed.
  return useGetCustomAuthenticationFactorRequirementsPreviewQuery(
    { templateId, customerId },
    { refetchOnMountOrArgChange: true, ...options, skip: options.skip || !templateId || !customerId },
  )
}
